import { useState } from 'react';
import { api, extractError } from '@/lib/api.js';
import { FieldTip } from '@/components/FieldTip.js';
import { PublicAuthShell } from '@/components/layout/PublicAuthShell.js';
import { Button } from '@/components/ui/Button.js';
import { Input } from '@/components/ui/Input.js';

type ForgotResponse = {
  ok: boolean;
  email_sent: boolean;
  dev_reset_url?: string;
};

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [emailSent, setEmailSent] = useState(true);
  const [devResetUrl, setDevResetUrl] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  return (
    <PublicAuthShell
      title="Esqueci a senha"
      subtitle="Informe seu e-mail para receber o link de redefinição de senha"
    >
      {sent ? (
        <div className="space-y-3 text-sm" style={{ color: 'var(--text2)' }}>
          <p>
            Se existir uma conta com este e-mail, enviaremos um link para criar uma nova senha.
            {emailSent
              ? ' Verifique a caixa de entrada e o spam.'
              : ' O envio por e-mail falhou no servidor — configure RESEND_API_KEY.'}
          </p>
          {devResetUrl ? (
            <p
              className="rounded-lg p-3 text-xs"
              style={{ border: '1px solid var(--warning)', background: 'var(--primary-soft)', color: 'var(--text)' }}
            >
              Dev:{' '}
              <a className="break-all underline" href={devResetUrl}>
                abrir link de redefinição
              </a>
            </p>
          ) : null}
        </div>
      ) : (
        <form
          className="flex flex-col gap-6"
          onSubmit={(e) => {
            e.preventDefault();
            setErr(null);
            setLoading(true);
            void api
              .post<ForgotResponse>('/auth/forgot-password', {
                email: email.trim().toLowerCase(),
              })
              .then((r) => {
                setEmailSent(r.data.email_sent);
                setDevResetUrl(r.data.dev_reset_url ?? null);
                setSent(true);
              })
              .catch((ex) => setErr(extractError(ex).message))
              .finally(() => setLoading(false));
          }}
        >
          <div className="flex flex-col gap-2">
            <FieldTip
              label="E-mail"
              hint="O e-mail com que você entra no Hack Academy."
            >
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </FieldTip>
          </div>
          {err ? (
            <p className="text-sm text-feedback">{err}</p>
          ) : null}
          <Button type="submit" disabled={loading} style={{ width: '100%', padding: '12px 16px' }}>
            {loading ? 'Enviando…' : 'Enviar link'}
          </Button>
        </form>
      )}
    </PublicAuthShell>
  );
}
